<template>
  <div class="person pc" v-if="!isMobile">
    <div class="bg-wrap">
      <img class="back" src="../../assets/img/back-bg.png" alt="">
      <img class="head" :src="info.headUrl" alt="">
      <img class="font" src="../../assets/img/font-bg.png" alt="">
    </div>
    <div class="box">
      <div class="text-wrap" @click="goDetail">
        <h3>{{info.name}}</h3>
        <p>{{info.office}}</p>
        <h4>{{info.title}}</h4>
        <p>{{info.desc}}</p>
      </div>
    </div>
  </div>
  <div class="person is-mobile" v-else @click="goDetail">
    <div class="top">
      <div class="bg-wrap">
        <img class="back" src="../../assets/img/back-bg.png" alt="">
        <img class="head" :src="info.headUrl" alt="">
        <img class="font" src="../../assets/img/font-bg.png" alt="">
      </div>
      <div class="person-msg">
        <h3>{{info.name}}</h3>
        <p>{{info.office}}</p>
      </div>
    </div>
    <div class="bottom">
      <h4>{{info.title}}</h4>
      <p>{{info.desc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goDetail () {
      if (this.info.link) {
        window.open(this.info.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.person.pc {
  position: relative;
  margin-top: 90px;
  width: 230px; height: 355px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    & .text-wrap {
      padding-top: 0;
      transform: translateY(0);

      & h3 {
        display: inline-block;
        background-image: linear-gradient(to right, $blue, $green);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    & .bg-wrap {
      transition: all .3s;
      opacity: 0;
    }

    & .box {
      box-shadow: 0px 2px 23px 2px rgba(0, 0, 0, 0.04);
    }
  }

  & .box {
    position: relative;
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 50px 23px 2px rgba(0, 0, 0, 0.02);
  }

  & .bg-wrap,
  & .text-wrap {
    position: absolute;
    top: 0; left: 0;
    // background: #FFF;
  }

  & .bg-wrap {
    height: 230px;
    z-index: 2;
    transition: all .3s;

    & img {
      display: block;
      width: 100%;
    }

    & .font {
      position: absolute; bottom: 3px; left: 0;
    }

    & .head {
      position: absolute; bottom: 3px; left: 50%;
      transform: translate(-50%);
    }
  }

  & .text-wrap {
    position: relative;
    padding: 20px 20px 20px;
    background: #FFF;
    transform: translateY(198px);
    transition: all .5s;
    color: $black;

    &::before {
      content: '';
      position: absolute; top: 0; left: 50%;
      width: 89px; height: 4px;
      background-image: linear-gradient(to right, $blue, $green);
      transform: translate(-50%);
    }

    & h3 {
      padding-top: 32px;
      margin-bottom: 8px;
      @include lineFont(23, 500);
    }

    & h4 {
      position: relative;
      margin-bottom: 10px;
      @include font(16, 500); line-height: 22px;

        &::before {
          content: '';
          position: absolute; top: -16px; left: 0;
          height: 1px; width: 100%;
          background: rgba($color: $lightGray, $alpha: .2);
        }
    }

    & p {
      margin-bottom: 32px;
      color: $gray;
      @include font(13, 400); line-height: 20px;

      &:first-of-type {
        @include row(3);
      }

      &:last-of-type {
        @include row(6);
      }
    }
  }
}

.person.is-mobile {
  display: flex; flex-wrap: wrap;
  margin: 45px auto 0;
  background: #FFF;
  box-shadow: 0px 4px 46px 4px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  .top, 
  .bottom {
    width: 100%;
  }

  .top {
    display: flex; align-items: center;
    margin-bottom: 15px;
    height: 97px;

    & .bg-wrap {
      position: relative;
      flex: none;
      width: 98px; height: 97px;

      & img {
        position: absolute;
        width: 100%;

        &.font {
         bottom: 0; left: 0;
        }

        &.head {
          bottom: 0; left: 50%;
          transform: translate(-50%);
        }
      }
    }

    & .person-msg {
      position: relative;
      margin: 0 16px;

      h3 {
        margin-bottom: 6px;
        @include lineFont(15, 500);
      }

      p {
        color: $gray;
        line-height: 16px;
        @include font(12, 400);
        @include row(3);
      }

      &:after {
        content: '';
        position: absolute; left: 0; bottom: -13px;
        width: 100%; height: 1px;
        background: $gray;
        opacity: .2;
      }
    }
  }

  .bottom {
    padding: 0 16px 18px;
    h4 {
      margin-bottom: 6px;
      @include lineFont(15, 500);
    }
    p {
      color: $gray;
      line-height: 16px;
      @include font(12, 400);
      @include row(4);
    }
  }
}
</style>